import { render, staticRenderFns } from "./ActivePatientCard.vue?vue&type=template&id=f4c842bc&scoped=true"
import script from "./ActivePatientCard.vue?vue&type=script&lang=js"
export * from "./ActivePatientCard.vue?vue&type=script&lang=js"
import style0 from "./ActivePatientCard.vue?vue&type=style&index=0&id=f4c842bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c842bc",
  null
  
)

export default component.exports